module.exports = __webpack_public_path__ + "static/media/img_4.3acd9d61.png";